var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-tabs',{attrs:{"default-active-key":"1"}},[_c('a-tab-pane',{key:"1",attrs:{"tab":_vm.$t('待办')}},[_c('Unprocessed',{attrs:{"id":_vm.id}})],1),_c('a-tab-pane',{key:"2",attrs:{"tab":_vm.$t('已办'),"force-render":""}},[_c('Completed',{attrs:{"id":_vm.id}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }